import React, { memo, useContext } from 'react'

import { AppId } from '@inno-tools/container-bridge'
import { useNavigate } from 'react-router-dom'
import { UserContext } from 'shared/contexts/User'

import { useAvailableApps } from '../hooks/useAvailableApps'
import { FullPageAppTemplate } from '../templates'

const TransferPricingApp = memo(
  () => {
    const navigate = useNavigate()
    const { location } = window
    const { user } = useContext(UserContext)
    const { apps } = useAvailableApps()

    return (
      <FullPageAppTemplate
        appId={AppId.TRANSFER_PRICING}
        scope='transfer_pricing'
        envKey={apps[AppId.TRANSFER_PRICING].runtimeEnvKey}
        hasFullHeight
        entryPath='./TransferPricingApp'
        url={process.env.REACT_APP_TRANSFER_PRICING_APP_DEV_PATH}
        appName={apps[AppId.TRANSFER_PRICING].name}
        appProps={{
          user,
          initialPath: apps[AppId.TRANSFER_PRICING].path,
          onNavigate: ({ pathname: nextPathname }: { pathname: string }) => {
            const { pathname } = location

            if (pathname !== nextPathname) {
              navigate(nextPathname)
            }
          }
        }}
      />
    )
  },
  () => true
)

export { TransferPricingApp }
